module.exports = __webpack_public_path__ + "img/security-time.66ffd5e4.svg";